import React from 'react';
import './Footer.css';
import profileImage from '../assets/image/profile.jpg'; // replace with correct path
import { FaWhatsapp, FaInstagram, FaTiktok, FaGlobe } from 'react-icons/fa';
import { InstagramOutlined, FacebookFilled, MenuOutlined, CloseOutlined,TikTokOutlined} from '@ant-design/icons';
import { BiFontSize } from 'react-icons/bi';

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="footer-main">
        <div className="footer-left">
          <img src={profileImage} alt="Klyssa Chong" className="footer-img" />
          <div className="footer-caption">
            <p>Klyssa Jamie Chong<br />Senior Associate Director<br />CEA No: R069265I</p>
          </div>
        </div>

        <div className="footer-right">
          <h2 className="footer-name">Klyssa Chong.</h2>
          <p className="footer-tagline">The Singaporean Real Estate Innovation</p>

        <div className="footer-links">
          
 
  <a href="https://instagram.com/klyssachong" target="_blank" rel="noreferrer">
    <InstagramOutlined className="footer-icon" />
  </a>
<a href="https://www.tiktok.com/@klyssachong" target="_blank" rel="noreferrer">
    <TikTokOutlined className="footer-icon" />
  </a>
</div>

<div className="footer-buttons">
  <a href="https://wa.me/6583342177" target="_blank" rel="noreferrer">
    <button className="footer-btn">
      <FaWhatsapp className="footer-icon" /> WhatsApp
    </button>
  </a>
  
  <a href="tel:+6583342177">
    <button className="footer-btn">
      📞 Give a Call
    </button>
  </a>
</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
